<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17NH2v/tc-custom/9781613769126.jpg?1705766069153" alt="This image is the cover for the book Union Like Ours"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Union Like Ours
      </h1>
      <p class="bookDescription body article font2">
        <b>“An example of how two men could—precariously and passionately—live together and love each other in the America of the 1930s and 1940s.” —Colm Tóibín, <i>New York Times</i>-bestselling author of <i>The Magician</i></b><br/><br/>After a chance meeting aboard the ocean liner <i>Paris</i> in 1924, Harvard University scholar and activist F. O. Matthiessen and artist Russell Cheney fell in love, and remained inseparable until Cheney’s death in 1945. During the intervening years, the men traveled throughout Europe and the United States, achieving great professional success while contending with serious personal challenges, including addiction, chronic disease, and severe depression.<br/><br/>Situating the couple’s private correspondence alongside other sources, Scott Bane tells the remarkable story of their relationship in the context of shifting social dynamics in the United States. From the vantage point of the present day, with marriage equality enacted into law, Bane provides a window into the realities faced by same-sex couples in the early twentieth century, as they maintained relationships in the face of overt discrimination and the absence of legal protections.<br/><br/>“A nuanced exploration of a marriage, one characterized by great joy but also buffeted by tremendous conflict (societal, financial, and health-related).” —R. Tripp Evans, author of <i>Grant Wood: A Life</i><br/><br/>“A smart, sensitive study of a gay couple…extremely readable.” —<i>Gay &amp; Lesbian Review</i><br/><br/>“An arresting account of how a same-sex relationship endured.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Scott Bane
      </h2>
      
      <p class="authorDescription body article">SCOTT BANE is a program officer at The John A. Hartford Foundation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Massachusetts Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20b6deee